export default {
      id: "vw-usage",
      viewBox: "0 0 191 40",
      url: __webpack_public_path__ + "sprite.svg#vw-usage",
      toString: function () {
        return this.url;
      }
    }